import { Component, OnInit, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { ViewContainerRef, OnDestroy } from '@angular/core';
import { Supplier } from '../supplier';
import { Branch } from '../../../accounting/branch';
import { SupplierService } from '../supplier.service';
import { LocationService } from 'services/location.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { SettingsService } from '../../../../shared/services/settings.service';
import { ExportService } from '../../../../shared/services/export.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { BranchService } from '../../../accounting/branches/branch.service';
import {Utils} from '../../../../shared/utils';

@Component({
  selector: 'app-suppliers-list',
  templateUrl: './suppliers-list.component.html',
  styleUrls: ['./suppliers-list.component.scss']
})
export class SuppliersListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  suppliers: Supplier[];
  subscriptions: Subscription[] = [];

  branchesBySupplier: any;
  allCity$: Observable<any[]>
  allCountry$: Observable<any[]>

  columns: ITdDataTableColumn[] = [
    { name: 'name', label: 'Name', tooltip: '' },
    { name: 'contact_person', label: 'Contact' },
    { name: 'address', label: 'Address' },
    { name: 'city_id', label: 'Location' },
    { name: 'phone', label: 'Phone' },
    { name: 'email', label: 'Email' },
    { name: 'branches', label: 'Branch' }
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 5;
  sortBy: string = 'name';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  selectedBranch: number = 0;
  allBranches$: Branch[];
  allCities: any = {};
  allCountries: any = {};

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _supplierService: SupplierService,
    private _branchService: BranchService,
    private _loadingService: TdLoadingService,
    private _locationService: LocationService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscriptions.push(this._supplierService
      .getSuppliers()
      .subscribe((suppliers: Supplier[]) => {
        this.getBranchesBySupplier(suppliers);

        if (Array.isArray(suppliers)) {
          this.suppliers = suppliers;
        } else {
          this.suppliers = [];
        }
        this.filteredData = this.suppliers;
        this.filteredTotal = this.suppliers.length;
        // this.selectedRows = this.filteredData;
        this.filter();

        this._loadingService.resolve('loading');

      }));

    this.allCountry$ = this._locationService.getCountry();

    //Use user's branches instead
    //this.subscriptions.push(this._supplierService.getBranches()
    this.subscriptions.push(Observable.of(this._authService.getUserBranches())
      .subscribe((branches: Branch[]) => {
        this.allBranches$ = branches;
        // this.allBranches$.unshift(new Branch({
        //   id: -1, name: 'All'
        // }));
        this.selectedBranch = -1;
      }));

    this.subscriptions.push(this._locationService.getCity()
      .subscribe((cities: any[]) => {
        cities.forEach(city => {
          this.allCities[city.id] = city;
        });

        // this._locationService.getCountry()
        //   .subscribe((countries: any[]) => {
        //     countries.forEach(country => {
        //       this.allCountries[country.id] = country;
        //     });
        //   });
      }));
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('supplier')) {
      this._searchBox.value = this._settingsService.getSearchTerm('supplier');
      this._searchBox.searchClicked();
    }
  }

  getBranchesBySupplier(suppliers: Supplier[]): void {
    this.branchesBySupplier = {};

    suppliers.forEach((supplier: Supplier) => {
      this.subscriptions.push(this._branchService
        .getBranchesBySupplier(supplier.id)
        .subscribe((branchesBySupplier: any) => {
          let derivedBranches = branchesBySupplier.branches;
          let supplierId = branchesBySupplier.supplierId;
          this.branchesBySupplier[supplierId] = derivedBranches.map(br => br.name);

          let supKey: any = this.suppliers.findIndex((item, index, arr) => {
            return item.id == supplierId;
          });

          if (supKey >= 0 && derivedBranches.length) {
            supKey = parseInt(supKey);
            this.suppliers[supKey].branches = derivedBranches;
          }

          this.filter();
        }));
    });
  }

  deleteSuppliers(): void {
    let deleteSuppliesCalls = [];
    let deleteBranchesCalls = [];
    let selectedSuppliers = this.selectedRows;
    let supplierIds = [];

    selectedSuppliers.forEach(sup => {
      let supplierId = sup.id;
      let supplierBranches = sup.branches;

      supplierIds.push(supplierId);

      deleteSuppliesCalls.push(
        this._supplierService
          .deleteSupplier(supplierId)
          .map((res: Response) => res)
      );

      if (supplierBranches) {
        supplierBranches.forEach((supBranch: any) => {
          deleteBranchesCalls.push(
            this._supplierService
              .deleteSupplierBranch(supplierId, supBranch.id)
              .map((res: Response) => res)
          );
        });

        Observable.forkJoin(deleteBranchesCalls).subscribe(data => {
          this.processDeleteSuppliers(deleteSuppliesCalls, supplierIds, selectedSuppliers);
        });
      } else {
        this.processDeleteSuppliers(deleteSuppliesCalls, supplierIds, selectedSuppliers)
      }
    });
  }

  processDeleteSuppliers(deleteSuppliesCalls: any, supplierIds: any, selectedSuppliers: any): void {
    Observable.forkJoin(deleteSuppliesCalls).subscribe(data => {
      this._dialogService.openAlert({
        message: 'Successfully deleted ' + (selectedSuppliers.length > 1 ? 'multiple suppliers' : '') + ' supplier!',
        title: 'Success',
      });

      this.suppliers = this.suppliers.filter((supplier: Supplier) => {
        return !~supplierIds.indexOf(supplier.id);
      });

      this.filter();
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('supplier', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.suppliers;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    if (this.selectedBranch > 0) {
      let selectedBranch: number = this.selectedBranch;
      newData = newData.filter(data => {
        return data.branches && !!~data.branches.findIndex(br => {
          return selectedBranch === br.id;
        });
      });
    }

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('supplier'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/suppliers/suppliers-list/suppliers-list.component.ts